import React, { Component } from "react";
import { withRouter } from "react-router-dom";
class SegmentSelect extends Component {
  render() {
    return (
      <option value={this.props.employee._id}>
        {this.props.employee.last_name}
        {"  "}
        {this.props.employee.first_name}
      </option>
    );
  }
}
export default withRouter(SegmentSelect);
